var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgActivateAccount = function SvgActivateAccount(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0ZM7.99687 12.4C7.99687 12.9523 8.44459 13.4 8.99687 13.4C9.54916 13.4 9.99687 12.9523 9.99687 12.4V10H12.1969C12.7492 10 13.1969 9.55229 13.1969 9C13.1969 8.44772 12.7492 8 12.1969 8H9.99687V6C9.99687 5.44771 9.54916 5 8.99687 5C8.44459 5 7.99687 5.44771 7.99687 6V8H5.79688C5.24459 8 4.79688 8.44772 4.79688 9C4.79688 9.55229 5.24459 10 5.79688 10H7.99687V12.4Z",
    fill: "#8075E6"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgActivateAccount);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "activate-account.89a7a82e2d080b023a57c8b18ddd099d.svg";